import React, { Component } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Popup from "reactjs-popup";
import CloseIcon from "@material-ui/icons/Close";
import { confirmAlert } from "react-confirm-alert"; // Import

import { BalanceService } from "../service/balance.service";
import { ConverMoeny } from "../utility/help";

import { ShareMenu } from "./share_menu";

export enum popupView {
  none = "none",
  deposit = "deposit",
  withdraw = "withdraw",
  point = "point",
  notice = "notice",
  note = "note",
  help = "help",
  user = "user",
  reg = "reg",
  login = "login",
  comp = "comp",
}

interface Props {
  user: any;
  handleClose: () => any;
  handleChange: (viewName: string) => any;
  updateUser: () => any;
}

interface State {
  balance: string;
  point: string;
}

export class Point extends Component<Props, State> {
  balanceService = new BalanceService();
  constructor(props: Props) {
    super(props);
    this.state = {
      balance: "0",
      point: "0",
    };
  }

  handleChangeToBalance = () => {
    if (Number(this.state.balance) <= 0) {
      confirmAlert({
        title: "벨런스",
        message: "벨런스를 입력해주세요.",
        buttons: [
          {
            label: "확인",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    confirmAlert({
      title: "벨런스",
      message: "보유머니를 입금 하시겠습니까?",
      buttons: [
        {
          label: "확인",
          onClick: () => {
            this.balanceService
              .user_balance_to_point(this.state.balance)
              .then((data: any) => {
                if (data.status === "success") {
                  confirmAlert({
                    title: "벨런스",
                    message: "벨런스를 금고머니로 변경하였습니다.",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                } else if (data.status === "low_point") {
                  confirmAlert({
                    title: "벨런스",
                    message: "보유금액 또는 보유포인트를 확인해주세요 .",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                } else {
                  confirmAlert({
                    title: "금고머니",
                    message: "보유머니를 초과하였습니다.",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                }
              });
          },
        },

        {
          label: "취소",
          onClick: () => {},
        },
      ],
    });
  };

  handleChangeToPoint = () => {
    if (Number(this.state.point) <= 0) {
      confirmAlert({
        title: "금고머니",
        message: "금고머니를 입력해주세요.",
        buttons: [
          {
            label: "확인",
            onClick: () => {},
          },
        ],
      });
      return;
    }

    confirmAlert({
      title: "금고머니",
      message: "금고머니를 출금하시겠습니까?",
      buttons: [
        {
          label: "확인",
          onClick: () => {
            this.balanceService
              .user_point_to_money(this.state.point)
              .then((data: any) => {
                if (data.status === "success") {
                  confirmAlert({
                    title: "금고머니",
                    message: "금고머니를 벨런스로 변경하였습니다.",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                } else if (data.status === "low_point") {
                  confirmAlert({
                    title: "벨런스",
                    message: "보유금액 또는 보유포인트를 확인해주세요 .",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                } else {
                  confirmAlert({
                    title: "금고머니",
                    message: "보유금을 초과 하였습니다.",
                    buttons: [
                      {
                        label: "확인",
                        onClick: () => {
                          window.location.reload();
                        },
                      },
                    ],
                  });
                }
              });
          },
        },

        {
          label: "취소",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    console.log(this.props.user);
    return (
      <Popup
        // key={`main_popup_note_${pop.idx}`}
        open={true}
        contentStyle={{
          zIndex: 99,
          background: "none",
          border: "none",
          width: "none",
        }}
        overlayStyle={{
          overflow: "scroll",
        }}
      >
        {(close) => (
          <>
            <div
              className="modal transferModal subpage-modal fade show"
              role="dialog"
              data-backdrop="static"
              style={{ display: "block" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <button
                    className="modal-close-btn modal-close"
                    data-dismiss="modal"
                    onClick={() => {
                      this.props.handleClose();
                    }}
                  ></button>
                  <div className="modal-menu">
                    <button
                      className="deposit-link"
                      onClick={() => {
                        this.props.handleChange(popupView.deposit);
                      }}
                    >
                      <div className="icon">
                        <i className="fas fa-money-bill-alt"></i>
                      </div>
                      <p className="kr-text">입금신청</p>
                      <p className="en-text">Deposit</p>
                    </button>
                    <button
                      className="withdraw-link"
                      onClick={() => {
                        this.props.handleChange(popupView.withdraw);
                      }}
                    >
                      <div className="icon">
                        <i className="fas fa-university"></i>
                      </div>
                      <p className="kr-text">출금신청</p>
                      <p className="en-text">Withdraw</p>
                    </button>
                    <button
                      className="active"
                      onClick={() => {
                        this.props.handleChange(popupView.point);
                      }}
                    >
                      <div className="icon">
                        <i className="fas fa-random"></i>
                      </div>
                      <p className="kr-text">금고</p>
                      <p className="en-text">Point</p>
                    </button>
                    <button
                      className="transfer-link"
                      onClick={() => {
                        this.props.handleChange(popupView.comp);
                      }}
                    >
                      <div className="icon">
                        <i className="fas fa-random"></i>
                      </div>
                      <p className="kr-text">콤프</p>
                      <p className="en-text">Comp</p>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="modal-title">
                      <h5 className="sub">Point</h5>
                      <h2 className="title">금고</h2>
                    </div>

                    <div className="form-container">
                      <div className="form-label">
                        <span className="labels blue">
                          <i className="fa fa-coins"></i> 보유머니 :
                        </span>
                        <span className="amount">
                          {ConverMoeny(this.props.user.balance)}{" "}
                          <span className="symbol">원</span>
                        </span>
                      </div>
                      <div className="form-label">
                        <span className="labels yellow">
                          <i className="fa fa-won-sign"></i> 금고머니 :
                        </span>
                        <span className="amount">
                          {ConverMoeny(this.props.user.point)}{" "}
                          <span className="symbol">원</span>
                        </span>
                      </div>
                      <div className="form-group w-btn">
                        <div className="labels">
                          <span>금고입금</span>
                          <span className="asterisk">*</span>
                        </div>
                        <div className="infos">
                          <div className="input-container">
                            <input
                              type="text"
                              placeholder="0"
                              value={this.state.balance}
                              readOnly
                              onFocus={() => this.setState({ balance: "" })}
                              onChange={(e) =>
                                this.setState({
                                  balance: e.target.value,
                                })
                              }
                            />
                          </div>
                          <button
                            className="form-btn btn-style"
                            onClick={this.handleChangeToBalance}
                          >
                            입금하기
                          </button>
                        </div>
                      </div>
                      <div className="form-group w-btn">
                        <div className="labels">
                          <span>금고출금</span>
                          <span className="asterisk">*</span>
                        </div>
                        <div className="infos">
                          <div className="input-container">
                            <input
                              type="text"
                              placeholder="0"
                              readOnly
                              value={this.state.point}
                              onFocus={() => this.setState({ point: "" })}
                              onChange={(e) =>
                                this.setState({
                                  point: e.target.value,
                                })
                              }
                            />
                          </div>
                          <button
                            className="form-btn btn-style"
                            onClick={this.handleChangeToPoint}
                          >
                            출금하기
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </Popup>
    );
  }
}
